export const install = Vue => {
  Vue.$bus = new Vue()

  Object.defineProperties(Vue.$bus, {
    on: { get () { return this.$on } },
    once: { get () { return this.$once } },
    off: { get () { return this.$off } },
    emit: { get () { return this.$emit } },
  })

  Object.defineProperties(Vue.prototype, {
    $bus: { get () { return Vue.$bus } },
  })

  Vue.mixin({
    created () {
      if (!this.$options.$bus) return
      this.$busListeners = { }

      Object.keys(this.$options.$bus).forEach(name => {
        if (typeof this.$options.$bus[name] !== 'function') {
          throw new Error(name + ' is not a function.')
        }

        const fn = this.$options.$bus[name].bind(this)
        this.$busListeners[name] = fn
        Vue.$bus.$on(name, fn)
      })
    },

    beforeDestroy () {
      if (!this.$options.$bus) return

      Object.keys(this.$options.$bus).forEach(name => {
        const fn = this.$busListeners[name]
        Vue.$bus.$off(name, fn)
      })

      delete this.$busListeners
    },
  })
}
